import usePurchaseTimeframeData from "../../hooks/usePurchaseTimeframeData";

/**
 * Selector de tiempo de compra para v2
 * Permite al usuario indicar cuándo quiere iniciar el proceso de compra
 */
const PurchaseTimeframeSelector = () => {
    const { getTimeframeOptions, getSelectedTimeframe, setTimeframeOption } =
        usePurchaseTimeframeData();

    const options = getTimeframeOptions();
    const selected = getSelectedTimeframe();

    // Maneja la selección de una opción de tiempo
    const handleOptionClick = (option) => {
        const label = option ? option.name : 'Solo estoy cotizando';

        if(dataLayer) {
            dataLayer.push({
                'event': 'cotizador',
                'eventCategory': 'iniciar_proceso_compra',
                'eventAction': 'cta',
                'eventLabel': label.replace(/\s+/g, '_').toLowerCase()
            });
        }
        setTimeframeOption(option);
    };

    return (
        <div className="purchase-timeframe-selector">
            {options.length ? (
                <>
                    <div className="component-header">
                        <h2>¿Cuándo quieres iniciar el proceso de compra?</h2>
                        <p>Elige tu plazo y recibe una atención personalizada acorde a tu momento.</p>
                    </div>
                    <div className="component-body">
                        {options.map((option) => (
                            <div
                                className={
                                    "item-box " +
                                    (selected && option.id === selected.id ? "active" : "")
                                }
                                key={`timeframe-${option.id}`}
                                onClick={() => handleOptionClick(option)}
                            >
                                <div className="prepaid-maintenance">
                                    <span className="name">{option.name}</span>
                                </div>
                            </div>
                        ))}
                        <div
                            className={"item-box " + (!selected ? "active" : "")}
                            onClick={() => handleOptionClick(null)}
                        >
                            <span>Solo estoy cotizando</span>
                        </div>
                    </div>
                </>
            ) : null}
        </div>
    );
};

export default PurchaseTimeframeSelector;
